import {
  getInvitationList,
  InvitationListResponse,
  SuccessResponse,
} from '@back-office/http';
import { cast } from 'mobx-state-tree';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* getInvitationListRequest(
  self: Self
): Generator<Promise<FlowReturn<InvitationListResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getInvitationList();
    const { status, data } = (response as InvitationListResponse).data;
    if (status.code === 1000) {
      self.invitations.reset();
      self.invitations.list = cast(data);
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default getInvitationListRequest;
